<template>
  <q-page padding>
    <div class="row col-12 align">
      <p class="text-h6 text-brand-5 text-weight-bold">
        Controle de Estoque (Compras Legado)
      </p>
    </div>

    <section class="row q-mt-md q-gutter-sm text-brand-5 text-weight-bold">
      <div class="col-md-3 q-mt-sm">
        <div>Unidade</div>
        <lista-unidades-select
          v-model="filtros.unidade"
        ></lista-unidades-select>
      </div>

      <div class="col-md-3 q-ml-sm q-mt-sm">
        <div>Estoque:</div>
        <q-select
          v-model="filtros.estoque"
          option-label="label"
          :options="listaEstoque"
          dense
          outlined
        />
      </div>

      <div class="col-md-3 q-ml-sm q-mt-sm">
        <div>Itens p/ Página:</div>
        <q-select
          v-model="filtros.paginas"
          :options="listaPaginas"
          dense
          outlined
        />
      </div>
      <div class="col-md-2 q-mt-sm">
        <div>Compra Aberta:</div>
        <q-input dense outlined v-model="filtros.aberta"> </q-input>
      </div>
      <div class="col-md-3">
        <div>Reposição:</div>
        <q-input dense outlined v-model="filtros.reposicao"> </q-input>
      </div>
      <div class="col-md-3 col-2">
        <div>Compra Sugerida:</div>
        <q-input dense outlined v-model="filtros.sugerida"> </q-input>
      </div>
    </section>

    <div class="q-mt-lg text-brand-5">
      <q-table
        flat
        table-header-class="bg-accent text-weight-bold"
        :title="
          'Produtos em estoque' + ' - ' + pagination.rowsNumber + ' ' + 'Itens'
        "
        :rows="rows"
        dense
        color="primary"
        :columns="columns"
        :filter="filtrar"
        title-class="text-brand-5 text-weight-bold"
        hide-pagination
        v-model:pagination="pagination"
        class="tabela-tamanho-fixo"
        @request="handleRequest"
      >
        <template v-slot:top-right>
          <q-input
            rounded
            outlined
            dense
            debounce="300"
            v-model="filtrar"
            placeholder="Buscar"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>

          <q-btn
            @click="exportar"
            class="q-ml-sm"
            icon="file_upload"
            no-caps
            color="secondary"
            label="Exportar"
          />
        </template>

        <template #body-cell-product_code="props">
          <q-td style="white-space: normal">
            <span class="text-brand-5 text-weight-bold">{{
              props.row.product_code
            }}</span>
          </q-td>
        </template>
        <template #body-cell-product_name="props">
          <q-td style="white-space: normal">
            <span class="text-brand-5 text-weight-bold">{{
              props.row.product_name
            }}</span>
          </q-td>
        </template>
        <template #body-cell-controla="props">
          <q-td style="white-space: normal" v-if="props">
            <q-toggle
              v-model="props.row.batch_control"
              :false-value="0"
              :true-value="1"
              @click="controla(props.row, props.row.batch_control == 1 ? 0 : 1)"
            />
          </q-td>
        </template>
        <template #body-cell-contrato="props">
          <q-td style="white-space: normal" v-if="props">
            <q-toggle
              v-model="props.row.contrato_fornecedor"
              :false-value="0"
              :true-value="1"
              @click="
                contrato(props.row, props.row.contrato_fornecedor == 1 ? 0 : 1)
              "
            />
          </q-td>
        </template>
      </q-table>
      <div class="row justify-center q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>
  </q-page>
</template>

<script>
const columns = [
  {
    name: "product_code",
    label: "Código do Produto",
    field: "product_code",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "product_name",
    label: "Produto",
    field: "product_name",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "product_group_name",
    label: "Grupo do Produto",
    field: "product_group_name",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "measurement_unit",
    label: "Unidade de Medida",
    field: "measurement_unit",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "measurement_unit_description",
    label: "Desc.Unid. de Medida",
    field: "measurement_unit_description",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "lote_compra",
    label: "Lote de Compra",
    field: "lote_compra",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "conta_contabil",
    label: "Conta Contabil",
    field: "conta_contabil",
    align: "left",
    style: "white-space: normal",
  },

  {
    name: "product_category_code",
    label: "Categoria",
    field: "product_category_code",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "price",
    label: "R$ Preço",
    field: "price",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "address",
    label: "Endereço do Produto	",
    field: "address",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "amount",
    label: "Estoque Atual",
    field: "amount",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "replacement_amount",
    label: "Ponto de Reposição",
    field: "replacement_amount",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "minimal_amount",
    label: "Estoque Crítico",
    field: "minimal_amount",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "max_amount",
    label: "Estoque Máximo",
    field: "max_amount",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "compra_sugerida",
    label: "Compra Sugerida",
    field: (row) =>
      row.compra_sugerida
        ? Number(row.compra_sugerida.replace(",", ".")).toFixed(2)
        : null,
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "controla",
    label: "Controla Lote",
    field: "controla",
    align: "left",
  },
  {
    name: "contrato",
    label: "Produto em Contrato",
    field: "contrato",
    align: "left",
  },
];

import { ref, onMounted, watch, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { watchDebounced } from "@vueuse/core";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
export default {
  components: { ListaUnidadesSelect },
  setup() {
    const store = useStore();
    const $q = useQuasar();
    const rows = ref([]);
    const disable = ref(true);
    const filtrar = ref("");
    const quasar = useQuasar();

    const filtros = ref({
      unidade: "",
      paginas: "",
      estoque: "",
      reposicao: "",
      aberta: "",
      sugerida: "",
    });

    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 25,
      rowsNumber: 15,
    });

    const getDados = async (page = 1, rowsPerPage = 25) => {
      quasar.loading.show();
      try {
        const response = await store.dispatch("ind/getCompras", {
          vendor_id: store.state.org.unidadeData.id,
          page,
          per_page: rowsPerPage,
          search: filtrar.value,
          compra_aberta:
            filtros.value.aberta != "" ? filtros.value.aberta : undefined,
          compra_sugerida:
            filtros.value.sugerida != "" ? filtros.value.sugerida : undefined,
          reposicao:
            filtros.value.reposicao != "" ? filtros.value.reposicao : undefined,
          stock:
            filtros.value.estoque && filtros.value.estoque.value != ""
              ? filtros.value.estoque.value
              : undefined,
        });

        rows.value = response.data.results.data;

        pagination.value.rowsPerPage = response.data.results.per_page;
        pagination.value.rowsNumber = response.data.results.total;
        pagination.value.page = response.data.results.current_page;
        disable.value = false;
        quasar.loading.hide();
      } catch (error) {
        quasar.loading.hide();
        $q.notify({
          message: "Erro ao encontrar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getDados);

    const controla = async (row, batch) => {
      const products = [
        {
          id: row.product_id,
          measurement_unit: row.measurement_unit,
          batch_control: batch == 0 ? 1 : 0,
        },
      ];
      try {
        await store.dispatch("ind/alterarControla", {
          products,
          vendor_id: store.state.org.unidadeData.id,
        });

        $q.notify({
          message: "Controla Lote alterado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getDados();
      } catch (error) {
        $q.notify({
          message: "Erro ao alterar Controla Lote",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const contrato = async (row, batch) => {
      try {
        await store.dispatch("ind/alterarContrato", {
          vendor_id: store.state.org.unidadeData.id,
          product_id: row.product_id,
          contrato: batch == 0 ? 1 : 0,
        });

        $q.notify({
          message: "Contrato alterado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getDados();
      } catch (error) {
        $q.notify({
          message: "Erro ao alterar Contrato",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const handleRequest = async () => {
      getDados(pagination.value.page, pagination.value.rowsPerPage);
    };

    const exportar = async () => {
      try {
        await store.dispatch("compras/exportarCompras", {
          vendor_id: store.state.org.unidadeData.id,
          page: pagination.value.page,
          per_page: pagination.value.rowsPerPage,
          search: filtrar.value,
          compra_aberta:
            filtros.value.aberta != "" ? filtros.value.aberta : undefined,
          compra_sugerida:
            filtros.value.sugerida != "" ? filtros.value.sugerida : undefined,
          reposicao:
            filtros.value.reposicao != "" ? filtros.value.reposicao : undefined,
          stock:
            filtros.value.estoque.value != ""
              ? filtros.value.estoque.value
              : undefined,
        });

        $q.notify({
          message: "Exportado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        $q.notify({
          message: "Erro ao exportar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => filtrar.value,
      () => {
        handleRequest();
      }
    );

    watchDebounced(
      [
        () => filtros.value.unidade,
        () => filtros.value.paginas,
        () => filtros.value.estoque,
        () => filtros.value.reposicao,
        () => filtros.value.aberta,
        () => filtros.value.sugerida,
      ],
      () => {
        pagination.value.rowsPerPage = filtros.value.paginas;
        handleRequest();
      },
      { debounce: 400 }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        getDados();
      }
    );

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        filtros.value.unidade = JSON.parse(getunidade);
      }
    };

    onMounted(getUnidade);

    return {
      pagination,
      rows,
      disable,
      columns,
      filtrar,
      getDados,
      handleRequest,
      listaPaginas: [25, 50, 100, 500],
      listaEstoque: [
        { label: "Ab. Reposição", value: "open_purchase" },
        { label: "Ab. Critico", value: "lower_crit" },
        { label: "Ac. Máximo", value: "max_amount" },
      ],
      filtros,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),

      exportar,
      contrato,
      controla,
    };
  },
};
</script>

<style>
.align {
  align-items: center;
}
</style>

<style>
/* .q-table__container .scroll {
  transform: rotateX(180deg);
}

.q-table__container .q-table {
  transform: rotateX(180deg);
} */

/* q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

.q-table--loading thead tr:last-child th {
  top: 48px;
}
.my-sticky-dynamic {
  max-height: 600px;
}
thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:last-child th {
  top: 48px;
}
thead tr:first-child th {
  top: 0;
} */
</style>
